/// <reference path='Dapi.d.ts' />
export default function publishAndObserveTitle(titleElement, dapi) {
    if (titleElement) {
        new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.target.textContent && mutation.target.textContent.trim() !== '') {
                    dapi.publishTitle(mutation.target.textContent.trim());
                }
                else if (titleElement.innerText && titleElement.innerText.trim() !== '') {
                    dapi.publishTitle(titleElement.innerText.trim());
                }
                else {
                    dapi.publishTitle(window.document.title.trim());
                }
            });
        }).observe(titleElement, { childList: true });
        if (titleElement.innerText && titleElement.innerText.trim() !== '') {
            dapi.publishTitle(titleElement.innerText.trim());
        }
        else {
            dapi.publishTitle(window.document.title.trim());
        }
    }
}
